import { Inject } from '@odinjs/odin';

import { APPLICATION_ROUTES, Endpoint, ToastServiceStipulator } from '@philips-emr/hpms-stipulator-commons';
import { FetchAPI, FormAPI, TextAPI, ToastNotificationAPI } from '@philips-emr/tws-components';
import { Value } from '@philips-emr/tws-core';
import Controller, { OnBeforeSubmit, OnCancel, OnClose, OnMount } from '@philips-emr/tws-core/lib/client';
import { AbortableSubmitEvent, MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { HistoryService, HttpService, msg } from '@philips-emr/tws-core/lib/services';

import BaseController from './BaseController';

@Controller({ fragment: 'alterar-vinculo' })
class AlterarVinculoController extends BaseController {

  @Inject('text-dsVinculo')
  private textDsVinculoAtual: TextAPI;
  @Inject('form-alterar-vinculo')
  private formDados: FormAPI;
  @Inject('toast-notification')
  private toastForm: ToastNotificationAPI;
  @Inject('fetch-atual')
  private fetchVinculoAtual: FetchAPI;

  @OnMount({ target: 'form-alterar-vinculo' })
  onMountForm(event: MountEvent): void {
    const apiForm = event.target as unknown as FormAPI;
    const { nrSeqBeneficiario, nrSeqContrato } = HistoryService.getCurrentRouteParams();

    void HttpService.get<Record<string, Value>>(Endpoint.GET.SOLIC_ALT_VINCULO_ABERTA, { nrSeqBeneficiario, nrSeqContrato })
      .then(response => {
        const { body: solicAberta } = response;

        if (!solicAberta) {
          this.executaConsultaVinculoAtual();
          return;
        }

        const { nrSeqSolicAlt, dsVinculo } = solicAberta;
        this.context.set({ nrSeqSolicAlt });

        apiForm.setData(solicAberta);

        if (!dsVinculo) {
          this.textDsVinculoAtual.setValue('-');
        }

      });
  }

  @OnBeforeSubmit({ target: 'form-alterar-vinculo' })
  onSubmit(event: AbortableSubmitEvent): void {
    const dados = this.formDados.getRecord();
    const { nrSeqBeneficiario, nrSeqContrato } = HistoryService.getCurrentRouteParams();
    const { nrSeqSolicAlt } = this.context.getBulkData();
    const body = { ...dados, nrSeqBeneficiario, nrSeqSolicAlt };

    HttpService.post(Endpoint.POST.SOLIC_ALT_VINCULO, { nrSeqBeneficiario, nrSeqContrato }, { body })
      .then(() => {
        ToastServiceStipulator.success(msg('stipuplator.alteracao.solicitada'));

        const { nrSeqGrupoContratoWeb, nrSeqContrato } = HistoryService.getCurrentRouteParams();
        HistoryService.push(APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO, { nrSeqGrupoContratoWeb, nrSeqContrato });
      }).catch(() => {
        this.toastForm.setVisible(true);
        event.abort();
      });
  }

  @OnCancel({ target: 'form-alterar-vinculo' })
  onCancelForm(): void {
    const { nrSeqGrupoContratoWeb, nrSeqContrato } = HistoryService.getCurrentRouteParams();
    HistoryService.push(APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO, { nrSeqGrupoContratoWeb, nrSeqContrato });
  }

  @OnClose({ target: 'toast-notification' })
  onCloseToast(): void {
    this.toastForm.setVisible(false);
  }

  private executaConsultaVinculoAtual(): void {
    const { nrSeqBeneficiario } = HistoryService.getCurrentRouteParams();
    this.context.set({ nrSeqBeneficiario });
    this.fetchVinculoAtual.forceFetch();
  }
}

export default AlterarVinculoController;
